// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"d34462bd","560":"b7ffa2fb"}[chunkId] + ".chunk.js";
};